// extracted by css-extract-rspack-plugin
export default {"menu":"menu-JPmlDs","header":"header-BU5Ux7","listScrollable":"listScrollable-UpfX3K","menuButton":"menuButton-R2_Ips","loaderContainer":"loaderContainer-OW2Tca"};